import { Link } from "react-router-dom";

export const Logo = ({
  size = "md",
  hero = false,
  asLink = true,
  variant = "dark",
  dataTestId = "logo",
}) => {
  const sizes = {
    sm: { text: "text-2xl", consulting: "text-[8px] tracking-[0.45em] mt-1" },
    md: { text: "text-4xl", consulting: "text-[10px] tracking-[0.5em] mt-1.5" },
    lg: { text: "text-6xl sm:text-7xl", consulting: "text-xs sm:text-sm tracking-[0.55em] mt-3" },
  };
  const s = sizes[size] || sizes.md;
  const light = variant === "light";
  const ideaColor = light ? "#A16207" : "#FACC15";
  const solidColor = light ? "#0A0A0A" : "#ffffff";

  const inner = (
    <div className="inline-flex flex-col items-center" data-testid={dataTestId}>
      <div
        className={`logo-frame ${hero ? "logo-frame--hero" : ""} ${light ? "logo-frame--light" : ""}`}
      >
        <span
          className={`font-black ${s.text} leading-none`}
          style={{
            fontFamily: "'Outfit', sans-serif",
            color: ideaColor,
            letterSpacing: "-0.04em",
          }}
        >
          idea
        </span>
        <span
          className={`font-light ${s.text} leading-none ml-1`}
          style={{
            fontFamily: "'Outfit', sans-serif",
            color: solidColor,
            letterSpacing: "-0.02em",
          }}
        >
          360
        </span>
      </div>
      <span
        className={`font-light ${s.consulting}`}
        style={{ fontFamily: "'Outfit', sans-serif", color: solidColor }}
      >
        CONSULTING
      </span>
    </div>
  );

  if (!asLink) return inner;
  return (
    <Link to="/" aria-label="Idea 360 Consulting — Home" data-testid="logo-link">
      {inner}
    </Link>
  );
};

export default Logo;
